import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AgGridListComponent } from '../../components/ag-grid-list/ag-grid-list.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { GlobalService } from '../../services/global.service';
import { DropdownService } from '../../services/dropdown.service';
import { ActivityLogService } from '../../services/activity-log.service';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-activity-log-list-page',
  imports: [CommonModule, FormsModule, HeaderComponent, AgGridListComponent, SearchInputComponent, SelectInputComponent, ButtonComponent],
  templateUrl: './activity-log-list-page.component.html',
  styleUrl: './activity-log-list-page.component.css'
})
export class ActivityLogListPageComponent {

  page_name = 'Activity Log';
  params: any = {};
  items: any = [];

  role_options: any[] = [];
  user_options: any[] = [];

  entity_options: any[] = [
    { title: 'Country', value: 'Country' },
    { title: 'State', value: 'State' },
    { title: 'City', value: 'City' },
    { title: 'District', value: 'District' },
    { title: 'School', value: 'University' },
    { title: 'School Branch', value: 'College' },
    { title: 'Program', value: 'Program' },
    { title: 'Course', value: 'Course' },
    { title: 'Subject', value: 'Subject' },
    { title: 'Stream', value: 'Stream' },
    { title: 'Level', value: 'Level' },
    { title: 'Academic Year', value: 'AcademicYear' },
    { title: 'Barcode', value: 'Barcode' },
    { title: 'Role', value: 'Role' },
    { title: 'User', value: 'User' },
    { title: 'Exam', value: 'Exam' },
    { title: 'Assessment', value: 'Assessment' },
    { title: 'Script', value: 'Script' },
    { title: 'Evaluation', value: 'Evaluation' },
    { title: 'Exception', value: 'Exception' },
    { title: 'Re-Evaluation', value: 'Re-Evaluation' },
    { title: 'Result', value: 'Result' },
    { title: 'Student Mapping', value: 'StudentMapping' },
    { title: 'Auth', value: 'Auth' },
  ];

  action_options: any[] = [
    { title: 'Add', value: 'Add' },
    { title: 'Update', value: 'Update' },
    { title: 'Delete', value: 'Delete' },
    { title: 'Assignment', value: 'Assignment' },
    { title: 'Mapping', value: 'Mapping' },
    { title: 'Evaluation', value: 'Evaluation' },
    { title: 'Exception', value: 'Exception' },
    { title: 'Re-Evaluation', value: 'Re-Evaluation' },
    { title: 'Publication', value: 'Publication' },
    { title: 'Login', value: 'Login' },
    { title: 'Logout', value: 'Logout' },
    { title: 'Upload', value: 'Upload' },
  ];

  bulk_columns: any = [
    { column_name: 'User Name', type: 'text', return_as: 'user_name' },
    { column_name: 'Role', type: 'text', return_as: 'role_name' },
    { column_name: 'Contact', type: 'text', return_as: 'contact' },
    { column_name: 'Email', type: 'text', return_as: 'email' },
    { column_name: 'Module', type: 'text', return_as: 'module' },
    { column_name: 'Sub-Module', type: 'text', return_as: 'sub_module' },
    { column_name: 'Date & Time', type: 'date', return_as: 'performed_at' },
    { column_name: 'Action', type: 'text', return_as: 'action' },
    { column_name: 'Description', type: 'text', return_as: 'description' },
  ];

  columns: any = [
    {
      headerName: 'User Name / Role', flex: 2, minWidth: 160,
      cellRenderer: (p: any) => {
        const name = p.data?.user_name || '-';
        const role = p.data?.role_name || '';
        return `<div style="display:flex;flex-direction:column;justify-content:center;height:100%;line-height:1.4"><span style="font-weight:600;font-size:13px">${name}</span>${role ? `<span style="font-size:12px;color:#6b7280">${role}</span>` : ''}</div>`;
      }
    },
    {
      headerName: 'Contact', flex: 1.5, minWidth: 140,
      cellRenderer: (p: any) => {
        const contact = p.data?.contact || '';
        const email = p.data?.email || '';
        if (!contact && !email) return '-';
        return `<div style="display:flex;flex-direction:column;justify-content:center;height:100%;line-height:1.4"><span style="font-size:13px;font-weight:600">${contact || '-'}</span><span style="font-size:12px;color:#6b7280">${email}</span></div>`;
      }
    },
    { headerName: 'Module', field: 'module', flex: 1.5, minWidth: 130 },
    { headerName: 'Sub-Module', field: 'sub_module', flex: 1.5, minWidth: 130 },
    {
      headerName: 'Date & Time', flex: 1.5, minWidth: 150,
      valueGetter: (p: any) => {
        if (!p.data?.performed_at) return '-';
        const d = new Date(p.data.performed_at);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
      }
    },
    {
      headerName: 'Action Taken', flex: 2, minWidth: 180,
      cellStyle: { background: '#EBF2FF' },
      cellRenderer: (p: any) => {
        const action = p.data?.action || '';
        const desc = p.data?.description || '';
        if (!action && !desc) return '-';
        const text = desc ? `${action} \u2013 ${desc}` : action;
        return `<div style="display:flex;align-items:center;height:100%;font-size:13px;font-weight:700;line-height:1.4">${text}</div>`;
      }
    },
  ];

  constructor(public gs: GlobalService, public ar: ActivatedRoute, public als: ActivityLogService, public dds: DropdownService, public fs: FormService,) { }

  async ngOnInit() {
    await this.dds.get_dropdown_list(['role', 'user']);
    this.role_options = this.dds.dropdown_list?.role_list || [];
    this.user_options = this.dds.dropdown_list?.user_list || [];

    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params };
      await this.get_list(this.params);
    });
  }

  async get_list(filter?: any) {
    try {
      const res = await this.als.get_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error('Error fetching activity logs:', error);
    }
  }

  apply_filters() {
    this.get_list({ ...this.params, page: 1 });
  }

  download() {
    this.fs.bulk_download(this.als, 'get_list', this.bulk_columns, 'Activity Logs', { ...this.params });
  }
}
